import axiosInstanceNew from "../lib/axiosinstanceNew";

const CotactlistModel = class {
  
  constructor() {
    this.baseUrl = "contact_person";
  }
  async list(data = []) {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}`)
    ).data;
  }
  async detail(id)
    {
        return (await axiosInstanceNew.get(`${this.baseUrl}/${id}`)).data;
    }
    async updateData(id,data= [])
    {
        return (
          await axiosInstanceNew.put(`${this.baseUrl}/${id}`,data))
    }
    async addcontact(data= []) {
      return (
        await axiosInstanceNew.post(`contact_person`,data))
    }
    async deletecontact(id) {
      return (
        await axiosInstanceNew.delete(`contact_person/${id}`))
    }
   // async disqualify(id, data=[])
    //{
    //    return  (
    //      await axiosInstanceNew.put(`tutor_enquiry/${id}`,data))
    //}
};

export default new CotactlistModel();
